import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/Api_Module/api/settings.service';
import { MantainCommand } from 'src/app/Api_Module/model/mantainSetting';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
  settings: MantainCommand[] = [];
  loadingSearch: boolean;
  selectedSetting: MantainCommand;
  messages = { emptyMessage: 'No settings found.', totalMessage: 'Total Settings' };
  constructor(private settingsService: SettingsService, private toastr: ToastrService) {
    this.loadingSearch = true;
    this.settingsService.get().subscribe((resp: MantainCommand[]) => {

      this.settings = resp;
      console.log(this.settings);
      this.loadingSearch = false;
    },
      error => {
        this.loadingSearch = false;
        this.toastr.error('Settings Not Found!');
        console.log('error:' + JSON.stringify(error));
      });
  }

  ngOnInit() {
  }

}
